import React from 'react';
import { Container } from '@ui';
import { PlanStep } from './PlanStep';

export const PlanStepList = ({ steps }) => {
  if (!steps || steps.length === 0) return null;

  return (
    <Container>
      {steps.map((step, index) => (
        <PlanStep key={index} data={step} />
      ))}
    </Container>
  );
};
